import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton
} from '@mui/material';
import Sidebar from '../../../Navigation/Sidebar/Sidebar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import './PostBills.css';

const PostBillsComponent = ({ activeBills, closedBills, loading, handleGoBack,viewInactiveBillDetails }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  return (
    <div className="post-bills-layout">
      <Sidebar />
      <div className="post-bills-content">
        <Box className="post-bills-header">
          <button className="pastback-button" onClick={handleGoBack}>
            ←
          </button>
          <Typography variant="h4" className="title">
            Past Bills
          </Typography>
        </Box>

        {loading ? (
          <div className="loading-container">
            <CircularProgress />
          </div>
        ) : (
          <div className="bills-section">
            <TableContainer component={Paper} className="bills-table">
              <Table>
                <TableHead>
                  <TableRow className="table-header">
                    <TableCell>Bill ID</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell className="view-button-cell">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="table-body">
                  {closedBills && closedBills.length > 0 ? (
                    closedBills.map((bill) => (
                      <TableRow key={bill.billId} className="table-row" hover>
                        <TableCell>{bill.billId}</TableCell>
                        <TableCell>{formatDate(bill.startDate)}</TableCell>
                        <TableCell>{formatDate(bill.endDate)}</TableCell>
                        <TableCell className="view-button-cell">
                         <IconButton onClick={() => viewInactiveBillDetails(bill.billId)} className="pastview-icon" size="small">

                            <VisibilityIcon  fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} className="no-bills-message">
                        No closed bills available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostBillsComponent;